//Importacion de los componentes
import Inicio from "../components/inicio.jsx";
import Login from "../components/login.jsx";
import Usuarios from "../components/Usuarios/Usuarios.jsx";
import Sorteo from "../components/Sorteo/sorteo.jsx";
import Versorteo from "../components/Sorteo/Versorteo.jsx";
import Venta from "../components/Venta/Venta.jsx";
import Captura from "../components/Venta/Captura.jsx";
import Perfil from "../components/Usuarios/Perfil.jsx";
import Liquidacion from "../components/Liquidacion/Liquidacion.jsx";
import Talonera from "../components/Venta/Talonera.jsx";
import CapturaNueva from "../components/Venta/CapturaNueva.jsx";
import Loading from "../components/Test/Loading.jsx";
import Paginacion from "../components/Test/Paginacion.jsx";
import Registros from "../components/Sorteo/Registros.jsx";
import QuickCapture from "../components/Venta/QuickCapture/index.jsx";
import { SorteosContextProvider } from "../components/Venta/QuickCapture/context/SorteosContext.jsx";
//Llamamos la parte del ENV




//Arreglo de las rutas
export var Approutes = [
    {
        path: `/`,
        component: <Login />,
        //layout: "/admin",
        name: "Login",
        icon: "fas fa-fw fa-line-chart",
        show: false,
        template: false,
        elements: [],
        permisos: []
    },
    {
        path: `/inicio`,
        component: <Inicio />,
        name: "Dashboard",
        icon: "fas fa-fw fa-chart-area",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2, 3, 4]
    },
    {
        path: `/usuarios`,
        component: <Usuarios />,
        name: "Usuarios",
        icon: "fas fa-fw fa-user-circle",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2]
    },
    {
        path: `/sorteos`,
        component: <Sorteo />,
        name: "Sorteos",
        icon: "fas fa-fw fa-file",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 4]
    },
    {
        path: `/captura`,
        component: <Venta />,
        name: "Captura",
        icon: "fas fa-fw fa-file-signature",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2, 3, 4]
    },
    /* {
        path: `/quick-capture`,
        component: <SorteosContextProvider><QuickCapture /></SorteosContextProvider>,
        name: "Captura rápida",
        icon: "fas fa-fw fa-file-signature",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2, 3, 4]
    }, */
    {
        path: `/liquidacion`,
        component: <Liquidacion />,
        name: "Liquidación",
        icon: "fas fa-fw fa-file",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2, 3]
    },
    {
        path: `/perfil`,
        component: <Perfil />,
        name: "Perfil",
        icon: "fas fa-fw fa-user-circle",
        show: true,
        template: true,
        //layout:null,
        elements: [],
        permisos: [1, 2, 3]
    },
];

//Arreglo de las subrutas
export var subrutas = [
    {
        path: `/sorteos/info/:id_sorteo`,
        component: <Versorteo />,
        name: "Info de los sorteos",
        icon: "fa-tachometer-alt",
        show: false,
        template: false,
        elements: []
    },
    {
        path: `/captura/info/:id_sorteo`,
        component: <CapturaNueva IsEspecial={false} />,
        name: "Info de las capturas",
        icon: "fa-tachometer-alt",
        show: false,
        template: false,
        elements: []
    },
    {
        path: `/captura/registros/:id_sorteo`,
        component: <Registros />,
        name: "Info de las capturas",
        icon: "fa-tachometer-alt",
        show: false,
        template: false,
        elements: []
    },
]

//export default Approutes;